import { globalUpgrades } from './components/global'
import { hhButtonWidgetUpgrades } from './components/HHButtonWidge'
import { hhTableUpgrades } from './components/HHTable'
import { formSelectUpgrades } from './components/FormSelect'
import { bigScreenHeaderTitleUpgrades } from './components/BigScreenHeaderTitle'
import { BigScreenMarquee } from './components/BigScreenMarquee'
import { HHDatetimePicker } from './components/HHDatetimePicker'
import { HHExportBtn } from './components/HHExportBtn'
import { HHGridUpgrades } from './components/HHGrid'
import { BigScreenCustomMapUpgrades } from './components/BigScreenCustomMap'
import { BigScreenZebraBarUpgrades } from './components/BigScreenZebraBar'
import { HHAssetsWidgeUpgrades } from './components/HHAssetsWidge'

export const schemaUpgradeRegistry = [
  globalUpgrades,
  hhTableUpgrades,
  hhButtonWidgetUpgrades,
  formSelectUpgrades,
  bigScreenHeaderTitleUpgrades,
  BigScreenMarquee,
  HHDatetimePicker,
  HHExportBtn,
  HHGridUpgrades,
  BigScreenCustomMapUpgrades,
  BigScreenZebraBarUpgrades,
  HHAssetsWidgeUpgrades
  // 可继续添加其他组件
]
